import React, { useContext } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useReservation } from '../Context/ReserveContextV2';
import { useAlert } from '../Context/AlertContext';
import { SalesRootContext } from '../Context/SalesRootContext';

const Layout = () => {
    const navigate = useNavigate();
    const { user, signOut } = useAuthenticator();
    const { isReserved } = useReservation();
    const { showAlert } = useAlert();
    const { salesRootData } = useContext(SalesRootContext);

    // console.log('Reservation Status:', isReserved);

    const handleSignOut = async () => {
        if (isReserved) {
            showAlert('ログアウトする前に、現在の予約を取り消してください。');
            return;
        }

        try {
            await signOut();
            navigate('/login');
        } catch (error) {
            console.error('ログアウトエラー:', error);
        }
    };

    return (
        <section className='layout'>
            <>
                {user ? (
                    <div className='header flexB'>
                        <button onClick={handleSignOut} className='endBtn buttonStyle'>終了</button>
                        <p className='userName'>
                           ユーザー名:【{salesRootData.TLAP_name}】ユーザーID:【{salesRootData.TLAP_id}】 グループ:【{salesRootData.group}】
                        </p>
                    </div>
                ) : (
                    <div className=''>
                        <img className='logo' src="/images/logo.png" alt="Example" />
                        <button className="loginBtn" onClick={() => navigate('/login')}>ログイン</button>
                    </div>
                )}
            </>
            <Outlet />
        </section>
    );
};

export default Layout;
